import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { getUrl } from "./urls";
import { getAccessToken } from "./utils";
// import { getInterval, getMetricsValue } from "./insightsActionUtils";

export const FETCH_YOUTUBE_PAGE_LIST = "FETCH_YOUTUBE_PAGE_LIST";
export const SET_YOUTUBE_SELECTED_PAGE = "SET_YOUTUBE_SELECTED_PAGE";
export const UPDATE_YOUTUBE_DURATION_FILTER = "UPDATE_YOUTUBE_DURATION_FILTER";
export const FETCH_YT_METRICS_PENDING = "FETCH_YT_METRICS_PENDING";
export const FETCH_YT_METRICS_FULFILLED = "FETCH_YT_METRICS_PENDING";
export const FETCH_YT_METRICS_REJECTED = "FETCH_YT_METRICS_REJECTED";
export const FETCH_YT_METRICS = "FETCH_YT_METRICS";
export const FETCH_YT_PAGE_FOLLOWERS = "FETCH_YT_PAGE_FOLLOWERS";

export function fetchYoutubePagesList() {
    let page_details = [];
    let res = axios({
        method: "get",
        url: getUrl("social_token_list"),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            response.data.data.tokens.map((k, v) => {
                // console.log("chck page instagram linkedin",youtube, k.platform);
                if (k.platform === "youtube" && k.insight_feature === 1) {
                    page_details.push(k);
                }
            });
            return page_details;
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_YOUTUBE_PAGE_LIST",
        payload: res,
    };
}

export function setSelectedPage(value) {
    return {
        type: "SET_YOUTUBE_SELECTED_PAGE",
        payload: value,
    };
}

export function updateDurationFilter(value) {
    return {
        type: "UPDATE_YOUTUBE_DURATION_FILTER",
        payload: value,
    };
}

export const fetchYTRecentPostsData = (dispatch, params, chartName) => {
    dispatch({
        type: "FETCH_YT_METRICS_PENDING",
        payload: { chart_name: chartName },
    });
    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            // console.log("ddddadadd", response.data?.hits);
            dispatch({
                type: "FETCH_YT_METRICS_FULFILLED",
                payload: { chart_name: chartName, response: response.data?.hits?.hits },
            });
        })
        .catch((error) => {
            console.log(error);
            dispatch({
                type: "FETCH_YT_METRICS_REJECTED",
                payload: { chart_name: chartName },
            });
        });
};

export const fetchYtNumberChartsByInsights = (data) => {
    let params = {};
    params["start_date"] = data.start_date;
    params["end_date"] = data.end_date;
    params["channel_ids"] = [data.handler];
    params["dimension"] = "day";
    params["debug"] = 0;
    params["interval"] = "year";
    params["aggs"] = ["total_count"];
    params["metrics"] = data.metrics;

    return axios.post(getUrl("youtube_opa_insights"), params, {
        cache: false,
    });
};
export const fetchYTPostDetailsBYAggs = (data) => {
    let params = new URLSearchParams();
    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("data", "0");
    params.append("orderBy", "post.published_date");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "50");
    params.append("apply_exclusion", "no");
    params.append("platform", ["6ce32d7c-a789-11e4-a34f-74867a1157ba"]);
    params.append("custom_query", `handlers:"${data.handler}"`);
    params.append("post_type", "0");
    params.append("send_agreegated_yt_data", 1);

    switch (data.name) {
        case "total-reach":
            params.append("aggs-interval", "year");
            params.append("aggs", "total_estimated_reach");
            break;

        case "total-engagement":
            params.append("aggs-interval", "year");
            params.append("aggs", "like-count-stats,share-count-stats,comment-count-stats,view-count-stats");
            break;

        case "total-posts":
            break;

        // case "total-posts-impressions":
        //     params.append("aggs-interval", "year");
        //     params.append("aggs", "view-count-stats");
        //     break;

        default:
            break;
    }

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};
export const fetchYTTotalSubs = (data) => {
    const chartName = data["name"];
    let url = `${getUrl("youtube_opa_total_subs")}?channel_ids=${data?.handler}`;

    return (dispatch) => {
        dispatch({
            type: "FETCH_YT_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        axios
            .get(url, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                    "access-token": getAccessToken(),
                },
            })
            .then((res) => {
                dispatch({
                    type: "FETCH_YT_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: res.data?.data?.channels?.[data?.handler] },
                });
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                dispatch({
                    type: "FETCH_YT_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};
export const fetchYoutubeData = (ApiCall, data) => {
    return (dispatch) => {
        const chartName = data["name"];

        dispatch({
            type: "FETCH_YT_METRICS_PENDING",
            payload: { chart_name: chartName },
        });

        let presentDurationData = ApiCall(data).then((res) => ({ name: "presentDurationData", data: res.data }));
        let data2 = { ...data };
        let durationGap = moment(data.end_date).diff(moment(data.start_date), "days", true);
        data2["start_date"] = moment(data.start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        data2["end_date"] = moment(data.start_date).subtract(1, "day").format("YYYY-MM-DD");

        let previousDurationData = ApiCall(data2).then((res) => ({ name: "previousDurationData", data: res.data }));

        Promise.all([presentDurationData, previousDurationData])
            .then((response) => {
                // console.log("checkkkk", chartName, response);
                dispatch({
                    type: "FETCH_YT_METRICS_FULFILLED",
                    payload: {
                        chart_name: chartName,
                        isAverage: data.isAverage,
                        response: response,
                        durationGap,
                    },
                });
                return response;
            })
            .catch((err) => {
                toast.error(err.response?.data.message);
                dispatch({
                    type: "FETCH_YT_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};

export const ytLowerChartsByInisights = (params) => {
    const chartName = params["name"];
    delete params["name"];

    return function (dispatch) {
        dispatch({
            type: "FETCH_YT_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let resp = axios({
            method: "post",
            url: getUrl("youtube_opa_insights"),
            data: params,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_YT_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: res.data },
                });
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                dispatch({
                    type: "FETCH_YT_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
};
export function fetchYTLowerCharts(params) {
    const chartName = params["name"];
    delete params["name"];

    return function (dispatch) {
        dispatch({
            type: "FETCH_YT_METRICS_PENDING",
            payload: { chart_name: chartName },
        });
        let resp = axios({
            method: "post",
            url: getUrl("searchaggs"),
            data: params,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "FETCH_YT_METRICS_FULFILLED",
                    payload: { chart_name: chartName, response: res.data },
                });
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                dispatch({
                    type: "FETCH_YT_METRICS_REJECTED",
                    payload: { chart_name: chartName },
                });
            });
    };
}
